/**
 * Piezas de presentación de un cliente que comparten la lista y el detalle de
 * la consola de plataforma (OT-0073 §4.3).
 */

import { useTranslation } from 'react-i18next'

import type { TenantAccess, TenantStatus } from '../../api/platform'
import {
  organizationState,
  organizationStateTone,
  formatDay,
  daysUntilReadOnly,
} from '../../lib/organizationState'

export function ClientStateBadge({
  client,
}: {
  client: { status: TenantStatus; access: TenantAccess }
}) {
  const { t } = useTranslation('platform')
  const state = organizationState(client)
  return (
    <span
      className={`inline-flex rounded px-2 py-0.5 text-xs font-medium ${organizationStateTone(state)}`}
    >
      {t(`clients.state.${state}`)}
    </span>
  )
}

/** Día en que el cliente pasa a sólo lectura y cuánto falta ("hoy",
 *  "mañana", "en N días"; nada si ya pasó); "—" para un cliente sin beta. */
export function TrialEnd({ trialEndsAt, locale }: { trialEndsAt: string | null; locale: string }) {
  const { t } = useTranslation('platform')
  const days = daysUntilReadOnly(trialEndsAt)
  if (days === null) return <span className="text-ink-subtle">—</span>
  return (
    <span className="text-ink">
      {formatDay(trialEndsAt, locale)}
      {days >= 0 ? (
        <span className="ml-1 text-xs text-ink-subtle">
          ({t('clients.read_only_in', { count: days })})
        </span>
      ) : null}
    </span>
  )
}
